import { BatchReturn, ReturnItem } from 'returnCenter-api';
import { isBatchAssignable } from 'hooks/useAutoApproveBatchHandling';

export type BatchMoveBlocker = 'processed' | 'completed';

/**
 * Why a row can no longer change batch, or null when it can. The server decides (a row moves until the
 * receiving company has made a return slip for it; out of a completed batch only when it was marked
 * missing), so the slip and the move never disagree.
 */
export const batchMoveBlocker = (item: ReturnItem): BatchMoveBlocker | null =>
    (item.batchMoveBlocker as BatchMoveBlocker | null | undefined) ?? null;

export const batchOptionLabel = (br: BatchReturn) =>
    `#${br.id} ${br.batchDestinationName ?? ''} ${br.comment ? `(${br.comment})` : ''} (${new Date(
        br.created!,
    ).toLocaleDateString()})`;

export const canMoveBatchRow = (item: ReturnItem) => isBatchAssignable(item) && batchMoveBlocker(item) == null;
